//AUTHORIZTION
export const VERIFY_TOKEN_STARTED = "VERIFY_TOKEN_STARTED";
export const VERIFY_TOKEN_END = "VERIFY_TOKEN_END";
export const USER_LOGIN_STARTED = "USER_LOGIN_STARTED";
export const USER_LOGIN_FAILURE = "USER_LOGIN_FAILURE";
export const VERIFY_USER_PHONE = "VERIFY_USER_PHONE";
export const USER_LOGOUT = "USER_LOGOUT";
export const VERIFY_USER_CODE = "VERIFY_USER_CODE";
export const REGISTERD = "REGISTERD";
export const VERIFY_USER_REGISTERED = "VERIFY_USER_REGISTERED";
export const USER_LOGIN = "USER_LOGIN";
export const LOGOUT_USER = "LOGOUT_USER";

//COMMON
export const NEW_CODING_DIALOG = "NEW_CODING_DIALOG";
export const DELETE_CODING_DIALOG = "DELETE_CODING_DIALOG";
export const NEW_LOCATION_DIALOG = "NEW_LOCATION_DIALOG";
export const DELETE_LOCATION_DIALOG = "DELETE_CODING_DIALOG";
export const LOGOUT_DIALOG = "LOGOUT_DIALOG";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
export const IS_BUSY = "IS_BUSY";

//CODING
export const NEXT_CODE = "NEXT_CODE";
export const PREV_CODE = "PREV_CODE";
export const LOAD_CODING_DATA = "LOAD_CODING_DATA";

//LOCATION
export const NEXT_LOCATION = "NEXT_LOCATION";
export const PREV_LOCATION = "PREV_LOCATION";
export const LOAD_LOCATION_DATA = "LOAD_LOCATION_DATA";

// ORDER
export const USER_TYPE_GOODS = "USER_TYPE_GOODS";
export const NEXT_FIRST_TAB = "NEXT_FIRST_TAB";
export const RETURN_TAB = "RETURN_TAB";
export const NEXT_SECOND_TAB = "NEXT_SECOND_TAB";
export const NEXT_THIRD_TAB = "NEXT_THIRD_TAB";
export const CALC_PRICE = "CALC_PRICE";
export const CLEAR_INITIAL = "CLEAR_INITIAL";

//  DETAILS
export const GET_ORDERS_DETAILS = "GET_ORDERS_DETAILS";
